import React, { useState, useCallback, useEffect } from 'react';
import { validateNumberValue } from '../../utils/common';
import { useFormContext } from 'react-hook-form';

export const TotalCard = ({ quotesArrayName, isCustomerFeasibilityEligible }) => {
    const { watch, setValue } = useFormContext();

    const [totalValues, setTotalValues] = useState({
        quantity: 0,
        total_price: 0,
    });

    const updateTotalValues = useCallback(
        (values) => {
            let quantity = 0;
            let total_price = 0;
            let quotes = values?.[quotesArrayName];
            if (Array.isArray(quotes)) {
                quotes.forEach((quote) => {
                    quantity += validateNumberValue(quote.quantity);
                    total_price += validateNumberValue(quote.unit_price) * validateNumberValue(quote.quantity);
                });
            }
            setTotalValues((prevState) => ({ ...prevState, quantity, total_price }));
        },
        [quotesArrayName]
    );

    useEffect(() => {
        const { unsubscribe } = watch((values) => {
            updateTotalValues(values);
        });
        return () => unsubscribe();
    }, [watch, setValue, quotesArrayName, updateTotalValues]);

    return (
        <div className='flex text-font11 bg-scogof8 py-4 rounded-b-lg'>
            <p className='w-80 truncate font-medium'></p>
            <p className='w-80 truncate font-medium'></p>
            <p className='w-24 truncate font-medium'></p>
            <p className='w-44 truncate font-medium'></p>
            <p className='w-36 truncate font-medium'></p>
            <p className='w-80 truncate font-medium'>Total</p>
            <p className='w-60 truncate'>{totalValues.quantity}</p>
            <p className='w-80 truncate'>{isNaN(totalValues.total_price) ? '0.00' : totalValues.total_price.toFixed(2)}</p>
        </div>
    );
};
